import React, { useEffect, useState } from 'react';
import CommonInput from '../../../components/Dashboard-res/CommonComponent/CommonInput';
import CommonSelect from '../../../components/Dashboard-res/CommonComponent/CommonSelect';
import get from 'lodash/get';
import styles from '../UserKycComponent/UserHRLetter/UserHR.module.css';
let relationShipOptions = [
  {
    label: 'Father',
    value: 'Father'
  },
  {
    label: 'Mother',
    value: 'Mother'
  },
  {
    label: 'Spouse',
    value: 'Spouse'
  },
  {
    label: 'Brother',
    value: 'Brother'
  },
  {
    label: 'Sister',
    value: 'Sister'
  },
  {
    label: 'Daugther',
    value: 'Daugther'
  },
  {
    label: 'Son',
    value: 'Son'
  },
  {
    label: 'Uncle',
    value: 'Uncle'
  },
  {
    label: 'Aunt',
    value: 'Aunt'
  },
  {
    label: 'GrandFather',
    value: 'GrandFather'
  },
  {
    label: 'Grandmother',
    value: 'Grandmother'
  }
];
const RelationShip = props => {
  const { relationShip_container } = styles;
  const {
    values,
    data,
    handleChange,
    errors,
    touched,
    handleBlur,
    setFieldError,
    setFieldValue,
    setFieldTouched
  } = props;
  return (
    <div
      className={`
       mt-8 ${relationShip_container}`}
    >
      <CommonSelect sort={true}
        name="relationShip"
        value={values.relationShip}
        onChange={anyvalue => {
          setFieldValue('relationShip', anyvalue, true);
          setFieldTouched('relationShip', true, false);
        }}
        onBlur={() => {
          setFieldTouched('relationShip', true, true);
        }}
        options={[
          {
            label: 'RelationShip',
            value: ''
          },
          ...relationShipOptions
        ]}
        stylesContainer={{
          height: '52px',
          marginBottom: '40px',
          fontSize: '40px'
        }}
        dropdownStyle={{
          top: '55px'
        }}
        styleText={{
          fontSize: '14px',
          padding: '0 25px'
        }}
        error={touched.relationShip && get(errors, 'relationShip.value', false)}
        errorMsg={get(errors, 'relationShip.value', false)}
        touched={touched.relationShip}
      />
      <CommonInput
        name="firstName"
        onChange={e => {
          handleChange(e);
          setFieldValue('firstName', e.target.value);
        }}
        onBlur={e => {
          handleBlur(e);
        }}
        value={values.firstName}
        stylesContainer={{
          maxWidth: '100%',
          marginBottom: '40px'
        }}
        legendName="First Name"
        error={touched.firstName && errors.firstName}
        errorMsg={errors.firstName}
        touched={touched.firstName}
      />
      <CommonInput
        name="middleName"
        onChange={e => {
          handleChange(e);
          setFieldValue('middleName', e.target.value);
        }}
        onBlur={e => {
          handleBlur(e);
        }}
        value={values.middleName}
        stylesContainer={{
          maxWidth: '100%',
          marginBottom: '40px'
        }}
        legendName="Middle Name"
        error={touched.middleName && errors.middleName}
        errorMsg={errors.middleName}
        touched={touched.middleName}
      />
      <CommonInput
        name="lastName"
        onChange={e => {
          handleChange(e);
          setFieldValue('lastName', e.target.value);
        }}
        onBlur={e => {
          handleBlur(e);
        }}
        value={values.lastName}
        stylesContainer={{
          maxWidth: '100%',
          marginBottom: '40px'
        }}
        legendName="Last Name"
        error={touched.lastName && errors.lastName}
        errorMsg={errors.lastName}
        touched={touched.lastName}
      />
    </div>
  );
};

export default RelationShip;
